import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('system-slide')) {
  page()
}

function page() {
  const mypageFavoriteSlide = new Swiper('#mypageFavoriteItemWrap', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 15,
    // centeredSlides: true, // 中央のスライドを基準にする
    loop: false, // ループ
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        centeredSlides: false,
      },
    },
  })

  const userColumnSlide = new Swiper('.js-userColumnItemWrap', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 15,
    // centeredSlides: true, // 中央のスライドを基準にする
    loop: false, // ループ
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
        centeredSlides: false,
      },
    },
  })
}

if (document.getElementById('a')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars

  const slideItem = document.getElementById('')

  // 各要素を取得
  const slideWrap = slideItem.querySelector('.swiper-wrapper')
  const slideList = slideItem.querySelectorAll('.swiper-slide')
  let slideCount = slideList.length // スライドの数

  const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
  // ループに不足するスライドを補充する
  while (slideCount < slidePerViewMax) {
    for (const iterator of slideList) {
      const clone = iterator.cloneNode(true)
      slideWrap.appendChild(clone)
      ++slideCount
    }
  }

  const sliderName = ''
  const Swiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（Swiper.init()で初期化）
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
    preloadImages: false, // スライド内の画像を読み終えてから開始
    // slidesPerView: 5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    // spaceBetween: 20, //スライド同士の間隔を空ける
    // slideToClickedSlide: true, // クリックしたスライドをアクティブにする
    // centeredSlides: true, // 中央のスライドを基準にする
    // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
    // grabCursor: true, // 掴みカーソル
    // simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
    touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）
    // autoHeight: true, // スライドごとに高さを変動させる
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    // hashNavigation: {  //ステート変更 「data-hash」必須
    //   watchState: true,
    //   replaceState: true,
    // },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
      // stopOnLastSlide: true, // 最終スライドに到達したら停止する
    },
    // pagination: {
    //   // ページャーオプション
    //   el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
    //   type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
    //   clickable: true, // クリックでジャンプ可能にする
    //   //   renderBullet: function(index, className) {
    //   //     // bulletsの描画内容を改変
    //   //     const targetImage = $('[data-swiper-slide-index="' + index + '"]')
    //   //       .find("img")
    //   //       .attr("src");
    //   //     return (
    //   //       '<div class="' +
    //   //       className +
    //   //       '"><img src=" ' +
    //   //       targetImage +
    //   //       ' " alt="ページ' +
    //   //       index +
    //   //       '" /></div>'
    //   //     );
    //   //   },
    // },
    // keyboard: {
    //   // キーボード操作
    //   enabled: true
    // },
    // mousewheel: {
    //   // マウスホイール操作
    // },
    // navigation: {
    //   nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
    //   prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    // },
    // scrollbar: {
    //   // スクロールバーオプション
    //   el: '.swiper-scrollbar--' + sliderName, // スクロールバーを呼び出す要素
    //   draggable: true // ドラッグを可能にする
    //   // dragSize: 50, //つまみの幅を固定する
    //   // snapOnRelease: true, //ドラッグ後に最寄りのスライドへ位置を補正する
    // },
    // lazy: {
    //   // 画像の遅延読み込み　preloadImagesがfalse前提
    //   loadPrevNext: true
    // },
    // breakpoints: {
    //   // 指定px以上でオプション切り替え
    //   769: {},
    // },
    // on: {
    //   init: function() {
    //     // 初期化完了時のコールバック
    //     // console.log('Slide-:init')
    //   }
    // }
  })
}
